import React from 'react';
import { CONTACTS } from '@department-of-veterans-affairs/component-library/contacts';
import PropTypes from 'prop-types';

import { AOJS } from '~/platform/shared/claims-appeals';
import NeedHelp from '../NeedHelp';

const VHA_HELP = {
  intro: 'Call Health Care Benefits',
  phone: CONTACTS['222_VETS'],
  vanity: 'VETS',
  hours: 'Monday through Friday, 8:00 a.m. to 8:00 p.m. ET.',
};

// NOTE: aoj stands for 'Agency of Original Jurisdiction'
const AppealHelpSidebar = ({ aoj }) => {
  switch (aoj) {
    case AOJS.vba:
      return <NeedHelp />;
    case AOJS.vha:
      return <NeedHelp help={VHA_HELP} />;
    case AOJS.nca:
    case AOJS.other:
      return null;
    default:
      return null;
  }
};

AppealHelpSidebar.propTypes = {
  aoj: PropTypes.oneOf(['vba', 'vha', 'nca', 'other']),
};

export default AppealHelpSidebar;
